import { KnyttPoint } from './KnyttPoint';
import { parseIniInt } from './KnyttUtil';
import type { KnyttArea } from './KnyttArea';

/** Per-area directional warp offsets, loaded lazily from the area's INI section. */
export class KnyttWarp {
  warpUp = KnyttPoint.Zero;
  warpDown = KnyttPoint.Zero;
  warpLeft = KnyttPoint.Zero;
  warpRight = KnyttPoint.Zero;
  loadedWarp = false;

  constructor(public readonly area: KnyttArea) {}

  loadWarpData(): void {
    if (this.loadedWarp) return;
    this.loadedWarp = true;
    this.warpUp = this.getIniWarp('U');
    this.warpDown = this.getIniWarp('D');
    this.warpLeft = this.getIniWarp('L');
    this.warpRight = this.getIniWarp('R');
  }

  getWarpCoords(newArea: KnyttPoint, currentArea: KnyttPoint): KnyttPoint {
    if (newArea.x < currentArea.x) return this.warpLeft;
    if (newArea.x > currentArea.x) return this.warpRight;
    if (newArea.y > currentArea.y) return this.warpDown;
    if (newArea.y < currentArea.y) return this.warpUp;
    return KnyttPoint.Zero;
  }

  private getIniWarp(dir: string): KnyttPoint {
    return new KnyttPoint(this.getDirWarp('X', dir), this.getDirWarp('Y', dir));
  }

  private getDirWarp(axis: string, dir: string): number {
    const key = `Warp${axis}(${dir})`;
    const data = this.area.extraData;
    if (!data || !data.has(key)) return 0;
    return parseIniInt(data.get(key)) ?? 0;
  }
}
